module.exports = __webpack_public_path__ + "img/role3.a9da0a1c.png";